import React, { Component } from 'react';
// import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { iPadBreakPoint, mobileBreakPoint } from 'src/utils/ResponsiveDesign';
import triangleLeftPng from './triangleLeft.png';
import triangleDownPng from './triangleDown.png';
import QAData from './QAData.json';

const Container = styled.div`
  width: 59%;
  border-right: 1px solid #c6c7c8;
  ${iPadBreakPoint} {
    width: 100%;
  }
  ${mobileBreakPoint} {
    width: 100%;
  }
`;

const Content = styled.div`
  width: 90%;
  margin: auto;
  ${'' /* border: 1px solid red; */}
`;

const Item = styled.div({
  width: '100%',
  marginBottom: '30px',
  '&:hover': {
    cursor: 'pointer',
  },
});

const Question = styled.div({
  display: 'flex',
});

const TriangleLeft = styled.img({
  width: '15px',
  height: '15px',
});

const QuestionInfo = styled.div({
  marginLeft: '10px',
  color: '#575757',
  letterSpacing: '1px',
  fontSize: '18px',
  lineHeight: '1.2',
});

const Answer = styled.div({
  background: '#f5f5f5',
  color: '#575757',
  marginTop: '15px',
  padding: '12px 30px',
  letterSpacing: '2px',
  lineHeight: '1.2',
  fontSize: '15px',
});

export default class QALeft extends Component {
  componentDidMount() {}

  state = {
    choseIndex: 0,
  };

  onQuestionToggle = index => {
    this.setState({ choseIndex: index });
  };

  render() {
    const { choseIndex } = this.state;
    return (
      <Container>
        <Content>
          {QAData.data.map((row, index) => {
            if (choseIndex === index) {
              return (
                <Item
                  key={row.question}
                  // eslint-disable-next-line
                  onClick={this.onQuestionToggle.bind(this, index)}
                >
                  <Question>
                    <TriangleLeft src={triangleDownPng} alt="" />
                    <QuestionInfo>{row.question}</QuestionInfo>
                  </Question>
                  <Answer>{row.answer}</Answer>
                </Item>
              );
            }
            return (
              <Item
                key={row.question}
                // eslint-disable-next-line
                onClick={this.onQuestionToggle.bind(this, index)}
              >
                <Question>
                  <TriangleLeft src={triangleLeftPng} alt="" />
                  <QuestionInfo>{row.question}</QuestionInfo>
                </Question>
              </Item>
            );
          })}
        </Content>
      </Container>
    );
  }
}
